import { cx } from "@indietabletop/appkit";
import { divider } from "./style.css.ts";

export function Divider(props: { className?: string }) {
  return <div {...cx(props, divider)} />;
}
